import converter from './Converter';
var FormulaParser = require('hot-formula-parser').Parser;

/**
 * Parse Condition for expr-eval
 *
 * @param {string} str text of "condition" files
 *
 * @return {object} contain the condition text parsed and variable needed for this condition
 */
function parseCondition(str) {
  //fill VariableNeeded
  let tmp = str;

  let reg = new RegExp("([a-zA-Z]+)(?=[^a-zA-Z])", 'g')
  let array1
  let result = []

  while ((array1 = reg.exec(tmp)) !== null) {
    result.push(array1[0].toLowerCase())
  }

  if (result.length === 0) {
      reg = new RegExp("^[a-zA-Z]$", 'g')

      while ((array1 = reg.exec(tmp)) !== null) {
          result.push(array1[0].toLowerCase())
      }
  }

  str = str.replace(new RegExp("!=", 'g'),'<>');
  str = str.replace(new RegExp(",", 'g'),'.');
  //str = str.replace(new RegExp("null", 'g'),'NULL');

  //Minus Everything And return condition parsed with variableNeeded
  return ({
      str: str.replace(new RegExp(";", 'g'),",").toLowerCase().replace(new RegExp("true", 'g'),'TRUE').replace(new RegExp("false", 'g'),'FALSE').replace(new RegExp("and", 'g'),'AND').replace(new RegExp("xor", 'g'),'XOR').replace(new RegExp("null", 'g'),'NULL'),
      VariableNeeded: result
  })
}

/**
 * Parse Condition for expr-eval
 *
 * @param {string} condition text of "condition" files
 * @param {object} allVariable contain all variables of the actual page
 *
 * @return {bool} return if the condition is passed
 */
function conditionCheckFunction(condition, allVariable) {

  let conditionTmp = parseCondition(condition);
  let stringCondition = conditionTmp['str']
  let variableNeeded = conditionTmp['VariableNeeded']
  var parser = new FormulaParser();

  if (variableNeeded != undefined || variableNeeded != null ) {
      variableNeeded = removeDuplicates(variableNeeded)

      Object.entries(variableNeeded).map((key, Mainindex) => {
          let tmpvar = key[1]

          Object.entries(allVariable).map((key, Mainindex) => {

              if (key[1].variable == tmpvar) {
                  parser.setVariable(tmpvar, key[1].value)
              }
              if (key[1].variableNum == tmpvar) {
                  parser.setVariable(tmpvar, key[1].variableNumValue)
              }
          })

      })
  }

  let result = parser.parse(stringCondition)

  return result['result']
}

/**
 * Remove duplicate field in array
 *
 * @param {array} arr an array
 *
 * @return {bool} return array without duplicate field
 */
function removeDuplicates(arr) {
  let unique_array = []
  for(let i = 0;i < arr.length; i++) {
      if (unique_array.indexOf(arr[i]) == -1) {
          unique_array.push(arr[i])
      }
  }
  return unique_array
}


function parseForumla(formula, allVariable, variableResult) {
  let tmp = parseCondition(formula);
  let form = tmp['str']
  let variableNeeded = tmp['VariableNeeded']
  let varValue = {}
  var parser = new FormulaParser();
  if (variableNeeded != undefined || variableNeeded != null ) {
      variableNeeded = removeDuplicates(variableNeeded)
  }

  Object.entries(variableNeeded).map((key, Mainindex) => {
      let variable = key[1]

      Object.entries(allVariable).map((key, Mainindex) => {
          if (key[1].variable === variable) {

              let units, unitFrom, unitTo, unitType;
              if (key[1].unitApp != undefined) {
                  units = key[1].unitApp.split(";");

                  if (units[1] != undefined && key[1].unit) {
                      unitType = units[0]
                      unitFrom = key[1].unit
                      unitTo = units[1]

                      if (unitFrom != unitTo) {
                          //Converter
                          parser.setVariable(variable, converter(unitType, key[1].value, unitFrom, unitTo))
                      }
                      else{
                          //Render value
                          parser.setVariable(variable, key[1].value)
                      }
                  } else {
                      parser.setVariable(variable, key[1].value)
                  }
              } else {
                  parser.setVariable(variable, key[1].value)
              }
          }
          else if (key[1].variableNum === variable) {
              parser.setVariable(variable, key[1].variableNumValue)
          }
      })
  })

  //Calcul
  // debugger;
  let result = parser.parse(form)

  Object.entries(allVariable).map((key, Mainindex) => {
    if (key[1].variable === variableResult) {
      let units, unitFrom, unitTo, unitType;

      if (key[1].unitApp != undefined) {
          units = key[1].unitApp.split(";");

          if (units[1] != undefined && key[1].unit) {
              unitType = units[0]
              unitFrom = units[1]
              unitTo = key[1].unit

              if (unitFrom != unitTo) {
                //Converter
                result['result'] = converter(unitType, result['result'], unitFrom, unitTo)
              }
          }
      }
    }
  })

  return result
}


function getVar() {
  let vars = [];
  let input = document.querySelectorAll('input[variable]');
  let select = document.querySelectorAll('select[variablenum]');

  //GET ALL QUESTION RESPONSE IN ARRAY
  Object.entries(input).map((key, Mainindex) => {
    let varTmp = {}
    let selectUnit = document.querySelector('select[variable="'+key[1].attributes.variable.value+'"]');
    varTmp.variable = key[1].attributes.variable.value;

    if (selectUnit != undefined || selectUnit != null) {
      if (selectUnit.options[selectUnit.selectedIndex] != undefined) {
        varTmp.unit = selectUnit.options[selectUnit.selectedIndex].text;
      }
    } else {
      varTmp.unit = undefined;
    }

    //Check if value is int or float or not a number (NaN = 0)
    let value;
    if (key[1].value === "") {
      value = 0;
    } else {
      //value = parseInt(key[1].value)
      if (key[1].value.indexOf(',') > -1 || key[1].value.indexOf('.') > -1) {
        value = parseFloat(key[1].value.replace(',','.'))
      } else {
        value = parseInt(key[1].value)
      }
    }
    if (isNaN(value)) {
      value = 0
    }

    varTmp.value = value

    if (key[1].attributes.unitapp != undefined) {
      varTmp.unitApp = key[1].attributes.unitapp.value

      let tmp = key[1].attributes.unitapp.value.split(";")
      if (tmp[1] === undefined) {
          //varTmp.value = undefined
      }
    }
    if (key[1].attributes.text != undefined) {
      varTmp.text = key[1].attributes.text.value
    }

    if (key[1].attributes.groupid != undefined) {
      varTmp.groupid = key[1].attributes.groupid.value
    }

    if (key[1].attributes.order != undefined) {
      varTmp.order = key[1].attributes.order.value
    }

    vars.push(varTmp)
  });

  //GET ALL LDC RESPONSE IN ARRAY
  Object.entries(select).map((key, Mainindex) => {
    let varTmp = {}
    let val = key[1].value
    let variablenumSecond;
    let selectVar = document.querySelectorAll('option[variablenum]');

    //Check if values are int or float
    if (key[1].options != null || key[1].options != undefined) {
      Object.entries(key[1].options).map((key, Mainindex) => {
        if (key[1].attributes.value != undefined) {

          if (key[1].value === val) {
              if (key[1].attributes[0].value.indexOf(',')>-1) {
                  variablenumSecond = parseFloat(key[1].attributes[0].value.replace(',','.'))
              } else {
                  variablenumSecond = parseInt(key[1].attributes[0].value)
              }
              varTmp.textChoose = key[1].text
          }
        }
      })
    }

    if (key[1].attributes.groupid != undefined) {
      varTmp.groupid = key[1].attributes.groupid.value
    }

    if (key[1].attributes.order != undefined) {
      varTmp.order = key[1].attributes.order.value
    }

    if (key[1].attributes.variableText != undefined) {
      varTmp.variableText = key[1].attributes.variableText.value
    } else {
      varTmp.variableText = null
    }

    varTmp.variableTextValue = val
    varTmp.variableNum = key[1].attributes.variableNum.value
    varTmp.variableNumValue = variablenumSecond

    if (key[1].attributes.unitapp != undefined) {
      varTmp.unitApp = key[1].attributes.unitapp.value
    }

    if (key[1].attributes.text != undefined) {
      varTmp.text = key[1].attributes.text.value
    }

    vars.push(varTmp)
  });

  return vars
}

function groupBy(arr, property) {
  return arr.reduce(function(memo, x) {
    if (!memo[x[property]]) { memo[x[property]] = []; }
    memo[x[property]].push(x);
    return memo;
  }, {});
}

export {parseCondition, conditionCheckFunction, removeDuplicates, parseForumla,
	getVar, groupBy};



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/ConfigFunction.js